<script lang="ts">
    import { kinshipsService, thirdsService } from "../services";
    import { Button, Icon } from "sveltestrap";
    import { Third_Kinship } from "../Model/ThirdKinship"
    import ThirdName from "./ThirdName.svelte"
    import AddThirdList from "./AddThirdList.svelte"
    import { createEventDispatcher } from "svelte"
    import KinshipThirdModal from "./KinshipThirdModal.svelte"
    import { v4 as uuidv4 } from 'uuid';

    const dispatch = createEventDispatcher();

    export let thirdId: string;

    let kinships: Third_Kinship[];

    let changeThird = false;
    let kinshipInfo: Third_Kinship = null;
    let third_relation = null

    let editKinship = null;

    let newKinship = {
        id: uuidv4(),
        kinship: null,
        member: 0,
        name: null,
        third_id: thirdId,
        third_relation: null
    }

    $: load(thirdId)

    async function load(thirdId){
        kinships = await kinshipsService.findOne(thirdId);
        
    }

    function kinshipUpdate (kinshipsEdit){
        for (const kinship of kinshipsEdit) {
            let kinshipEdit = kinships.find(p => p.id == kinship.id)

            if (kinshipEdit) {
                kinshipEdit = kinship
            }else{
                kinships = [...kinships, kinship];
            }
        }

        kinships = kinships;

        load(thirdId);
    }

    async function deleteKinship(kinshipId) {
        if (!confirm('¿Esta seguro de querer eliminar esta relación?')) {
            return
        }
        await kinshipsService.deleteKinship(kinshipId);
        location.reload()
    }

</script>

<style>

</style>

        <div class="row">
            <div class="col-12 text-end mt-3 mb-3">
                <button class="btn btn-primary" type="button" on:click={() => {editKinship = newKinship}}>
                    Añadir
                </button>
            </div>
            {#if kinships?.length}
                <div class="col-12">
                    <table class='table gap-3'>
                        {#each kinships as kinship}
                            {#if kinship.member}
                                <tr>
                                    <td class='pt-3 pb-3'>
                                        Pertenece a {kinship.name}
                                        <div class="float-end">
                                            <button 
                                                class="btn" 
                                                type="button" 
                                                on:click={() => editKinship = kinship}
                                                >
                                                    <Icon name='pencil' />
                                            </button>
                                            <button 
                                                type="button"
                                                class="btn text-right"  
                                                on:click={() => deleteKinship(kinship.id)}
                                                >
                                                    <Icon name='eraser' />
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            {:else}
                                <tr>
                                    <td class='pt-3'>{kinship.name} de:</td>
                                </tr>
                                <tr>
                                    <td class='ml-4 pb-3'>
                                        <ThirdName id={third_relation ? third_relation : kinship.third_relation} list={false} link/>
                                        <div class="float-end">
                                            <button 
                                                class="btn" 
                                                type="button" 
                                                on:click={() => editKinship = kinship}
                                                >
                                                    <Icon name='pencil' />
                                            </button>
                                            <button 
                                                type="button"
                                                class="btn text-right"  
                                                on:click={() => deleteKinship(kinship.id)}
                                                >
                                                    <Icon name='eraser' />
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            {/if}
                        {/each}
                    </table>
                </div>
            {:else}
                
                <div class="text-center pt-5">
                    <hr>
                    <h3>No hay parentezcos para mostrar</h3>
                </div>
            {/if}
        </div>

<KinshipThirdModal  bind:kinship={editKinship}  on:registerUpdate={() => kinshipUpdate(editKinship)} />

<!-- <AddKinshipModal 
    open={addKinship} 
    toggle={toggleModal} 
    editKinship={editKinship} 
    removeButton={true}
    on:addKinship={(event) => addNewKinship(event.detail)}
    on:removeKinship={(event) => removeKinship(event.detail)}
/> -->



